import UIHelper from '../ui-helper';

/**
 * Responsible for converting activity mastery report data from redux store into
 * format needed for export endpoints
 */
export default class ActivityMasteryDataConverter {
    static convertAllClasses(data, selectedDate, reportTitle, isAllYears) {
        const {
            allClassesActivityMastery,
            classroomActivityMasterys,
            courseStrengths,
            courseWeaknesses
        } = data;
        const {
            goldBars,
            scoreBand,
            totalActivities
        } = allClassesActivityMastery;
        const {
            mastered,
            consolidating,
            developing,
            emerging,
            needsImproving
        } = scoreBand;

        const i18n = window.i18n;
        return {
            dateRange: UIHelper.formatDateRange(selectedDate),
            activityMasteryTableHeader: isAllYears
                ? i18n._('Export - All years')
                : i18n._('Export - All classes'),
            reportLevelHeader: reportTitle,
            courseInsightsTableHeader: isAllYears
                ? i18n._('Label - Year')
                : i18n._('Label - Class'),
            classroomsActivityMasteryData: {
                allClassroomActivityMasterys: {
                    allGoldbars: goldBars,
                    allMasteredScores: mastered,
                    allConsolidatingScores: consolidating,
                    allDevelopingScores: developing,
                    allEmergingScores: emerging,
                    allNeedsImprovingScores: needsImproving,
                    allTotalActivities: totalActivities,
                    classroomActivityMasterys
                },
                courseStrengths: this.mapStrengthWeakness(courseStrengths),
                courseWeaknesses: this.mapStrengthWeakness(courseWeaknesses)
            }
        };
    }

    static convertSingleClass(data, selectedDate, groupId) {
        let groupActivityMastery = [
            ...data.activityMastery.groupActivityMastery
        ];
        if (groupId) {
            groupActivityMastery = groupActivityMastery.filter(
                (group) => group.id === groupId
            );
        }
        groupActivityMastery = groupActivityMastery.map(
            (group) => ({
                id: group.id,
                name: group.name,
                courseName: group.courseName,
                totalActivities: group.totalActivities,
                students: group.students,
                ...this.getTopicActivityStrengthWeakness(group)
            }),
            this
        );

        return {
            dateRange: UIHelper.formatDateRange(selectedDate),
            selectedGroupId: groupId || 0,
            classroomActivityMasteryData: {
                name: data.name,
                teachers: [
                    {
                        teacherName: data.teacherName
                    }
                ],
                totalGoldBars: data.activityMastery.goldBars,
                totalActivities: data.activityMastery.totalActivities,
                classScoreBand: data.activityMastery.scoreBand,
                groupActivityMastery,
                ...this.getTopicActivityStrengthWeakness(data)
            }
        };
    }

    static convertStudent(data, selectedDate, student) {
        const topicActivityResults = data.topicActivityResults.map(
            (topic) => ({
                ...topic,
                activityResultDetails: topic.activityResultDetails.map(
                    (activity) => ({
                        ...activity,
                        result: activity.result === -1 ? 0 : activity.result
                    })
                )
            }),
            this
        );

        return {
            dateRange: UIHelper.formatDateRange(selectedDate),
            studentActivityMasteryData: {
                className: data.className,
                courseInfo: data.courseInfo,
                topicActivityResults,
                userProfileId: student.id,
                firstName: student.name,
                lastName: '',
                ...this.getTopicActivityStrengthWeakness(data)
            }
        };
    }

    static getTopicActivityStrengthWeakness(data) {
        return {
            topicStrengths: this.mapStrengthWeakness(data.strengths.topics),
            topicWeaknesses: this.mapStrengthWeakness(data.weaknesses.topics),
            activityStrengths: this.mapStrengthWeakness(
                data.strengths.activities
            ),
            activityWeaknesses: this.mapStrengthWeakness(
                data.weaknesses.activities
            )
        };
    }

    static mapStrengthWeakness(data) {
        if (data.length === 1 && data[0].title === '-') {
            return [];
        }
        return data;
    }
}



// WEBPACK FOOTER //
// ./helpers/export-data-converter/activity-mastery-data-converter.js